(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["spg-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const summary=event.target.closest('.spg-faq summary');if(!summary)return;event.preventDefault();event.stopImmediatePropagation();const details=summary.parentElement;details.open=!details.open;},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spg-header"] && !Shopify.designMode) return;
  try {
    
function initSPGHeaders(){document.querySelectorAll('[data-spg-header]').forEach(header=>{if(header.dataset.ready)return;header.dataset.ready='true';const browse=header.querySelector('.spgh__browse');const categories=[...header.querySelectorAll('.spgh__category')];categories.forEach(category=>{category.querySelector('summary').addEventListener('click',event=>{if(category.open&&window.matchMedia('(min-width:990px)').matches)event.preventDefault();else categories.forEach(other=>{if(other!==category)other.open=false;});});});header.addEventListener('keydown',event=>{if(event.key==='Escape'&&browse.open){browse.open=false;browse.querySelector('summary').focus();}});document.addEventListener('click',event=>{if(!header.contains(event.target))browse.open=false;});});}
initSPGHeaders();document.addEventListener('shopify:section:load',initSPGHeaders);window.addEventListener('pageshow',()=>{document.querySelectorAll('[data-spg-header]').forEach(header=>{const url=window.Shopify?.routes?.root;if(!url)return;fetch(url+'cart.js').then(response=>response.ok?response.json():null).then(cart=>{if(cart)header.querySelector('[data-spg-cart-count]').textContent=cart.item_count;}).catch(()=>{});});});

  } catch(e) { console.error(e); }
})();
})();
